import { useQuery } from '@tanstack/react-query';
import { conferenceLogsApi } from './api';
import type { ListConferenceLogsParams } from './callLogTypes';

const keys = {
  list: (p: ListConferenceLogsParams) => ['conference-logs', 'list', p] as const,
  detail: (id: string) => ['conference-logs', 'detail', id] as const,
};

/** Paginated conference history (owner-scoped).
 *
 *  `enabled` lets a caller hold the fetch back until the tab is actually
 *  reachable — the feed is served by the calling service, so firing it where
 *  calling is switched off would only ever produce an error. */
export function useConferenceLogs(
  params: ListConferenceLogsParams = {},
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: keys.list(params),
    queryFn: () => conferenceLogsApi.list(params),
    staleTime: 30_000,
    enabled: options.enabled ?? true,
  });
}

/** One conference's full history record (participants + per-leg durations). */
export function useConferenceLogDetail(conferenceId: string | null) {
  return useQuery({
    queryKey: conferenceId ? keys.detail(conferenceId) : ['conference-logs', 'detail', 'none'],
    queryFn: () => conferenceLogsApi.detail(conferenceId as string),
    enabled: !!conferenceId,
    staleTime: 30_000,
  });
}
